import { useState } from "react";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import { useCashFlowsWidgetData } from "../widgetHooks";
import CashFlowsWidgetListDialog from "./CashFlowsWidgetListDialog";
import TabularWidgetPreviewCard from "./TabularWidgetPreviewCard";

interface Props {
  widgetSettings: PortalWidget;
}

const CashFlowsWidgetPreviewCard = ({ widgetSettings }: Props) => {
  const [showFullWidget, setShowFullWidget] = useState(false);

  const { report, fetchError } = useCashFlowsWidgetData(widgetSettings, {
    rowsLimit: 1,
  });

  return (
    <>
      <TabularWidgetPreviewCard
        widgetSettings={widgetSettings}
        report={report}
        fetchError={fetchError}
        onViewAllClick={() => setShowFullWidget(true)}
      />

      {showFullWidget && (
        <CashFlowsWidgetListDialog widgetSettings={widgetSettings} onClose={() => setShowFullWidget(false)} />
      )}
    </>
  );
};

export default CashFlowsWidgetPreviewCard;
